<template>
  <div id="banner">
    <div class="swiper-container swiper-container2">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
          <img :src="item.coverImgUrl" alt="">
        </div>
<!--        <div class="swiper-slide">
          <img src="@/assets/img/banner/banner3_zip.png" alt="">
        </div>
        <div class="swiper-slide">
          <img src="@/assets/img/banner/banner3.png" alt="">
        </div>-->
      </div>
      <!-- 如果需要分页器 -->      <!-- 如果需要导航按钮 -->
<!--      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>-->
    </div>
  </div>

</template>

<script>
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import Swiper from "swiper"
export default {
  name: "BannerList",
  props: {
    bannerList: {
      type: Array,
      default: () => [],
    }
  },
  mounted() {
    new Swiper('.swiper-container2', {
      direction: 'horizontal', // 垂直切换选项
      autoplay: { //自动开始
        delay: 3000, //时间间隔
        disableOnInteraction: false, //*手动操作轮播图后不会暂停*
      },
      loop: false, // 循环模式选项
      // 如果需要分页器
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true, // 分页器可以点击
      //   bulletClass: 'swiper-pagination-bullet',
      //   bulletActiveClass: 'my-bullet-active',
      // },
      // // 如果需要前进后退按钮
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
    })
  },
}
</script>

<style scoped lang="scss">
#banner{
  height: 560px;
  width: 100%;
  background-color: #fff;
}

#banner .swiper-container{
  width:100%;
  height: 560px;
}
#banner img{
  width:100%;
  height: auto;
}

.swiper-button-prev:after{
  display: none;
}
.swiper-button-next:after {
  display: none;
}
::v-deep .my-bullet-active{
  background: rgba(255,255,255,1)!important;
  width: 38px!important;
  border-radius: 4px!important;
}
::v-deep .swiper-pagination-bullet{
  background-color: #fff!important;
}
.swiper-button-prev{
  width: 54px!important;
  height: 54px!important;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/banner/arrow_left.png');
  background-size: 54px 54px;
  left: 164px!important;
}

.swiper-button-next {
  width: 54px!important;
  height: 54px!important;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/banner/arrow_right.png');
  background-size: 54px 54px;
  right: 164px!important;
}
</style>